export const SET_RECEIPT_TEMPLATES = "SET_RECEIPT_TEMPLATES";
export const SET_SELECT_RECEIPT_TEMPLATES = "SET_SELECT_RECEIPT_TEMPLATES";
export const SET_PAGINATION_TEMPLATES = "SET_PAGINATION_TEMPLATES";
export const SET_CLEAR_RECEIPT_TEMPLATES = "SET_CLEAR_RECEIPT_TEMPLATES";
